import { getActionName as getActionNameSkyBase } from '@kistler/skybase-ui/skybase-core/utils/get-action-name'
import config from '@/config'

export const getActionName = name => getActionNameSkyBase(name, config.actionNamespace)
